export function deckCardListExercise(card, exercises) {
  if (card?.exercise?.id) {
    return card.exercise;
  }
  return exercises?.find(item => item.id === card?.exerciseId);
}

export function deckCardListText(card, exercises) {
  const exercise = deckCardListExercise(card, exercises);

  return card?.frontText ||
    card?.sentence?.displayTargetText ||
    card?.sentence?.targetText ||
    card?.word?.targetTextWithDefiniteArticle ||
    card?.prompt ||
    card?.interjectionCode ||
    exercise?.exerciseEntries?.[0]?.sentence?.displayTargetText ||
    exercise?.exerciseEntries?.[0]?.word?.targetTextWithDefiniteArticle;
}

export function deckCardListTypeName(card, exercises) {
  const exerciseTypeName = deckCardListExercise(card, exercises)?.exerciseType?.name;
  if (exerciseTypeName) {
    return `${exerciseTypeName} Exercise`;
  }
  return card?.cardType?.name || card?.cardRule?.cardType?.name || 'Unknown Card Type';
}
